export class AiAssistantRouteId {
  public static readonly app = 'ai-assistant';
  public static readonly assistant = 'ai-assistant/assistant';
  public static readonly conversations = 'ai-assistant/assistant/conversations';
  public static readonly actions = 'ai-assistant/assistant/actions';
  public static readonly skills = 'ai-assistant/assistant/skills';
  public static readonly tools = 'ai-assistant/assistant/tools';
  public static readonly dashboard = 'ai-assistant/dashboard';
  public static readonly tracker = 'ai-assistant/tracker';
}
